import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from "react";
import { useMatchBreakpoints } from "../../hooks";
export var MatchBreakpointsContext = /*#__PURE__*/ createContext({
    isMobile: false,
    isTablet: false,
    isDesktop: false
});
export var MatchBreakpointsProvider = function(param) {
    var children = param.children;
    var state = useMatchBreakpoints();
    return /*#__PURE__*/ _jsx(MatchBreakpointsContext.Provider, {
        value: state,
        children: children
    });
};
